import {
  selectCrossSectionEnabledForTomographicView,
  selectSheetElevation,
} from "@/store/modes/sheet-cad-alignment-mode-selectors";
import { setCrossSectionEnabled } from "@/store/modes/sheet-cad-alignment-mode-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { ViewDiv } from "@faro-lotv/app-component-toolbox";
import type { JSX } from "react";
import { CrossSectionToggleButton } from "../alignment-modes-commons/cross-section-toggle-button";
import { useOverlayElements, useOverlayRef } from "../overlay-elements-context";

/**
 * @returns cad tomographic view toggle cross-section vs full CAD
 */
export function SheetCadCrossSectionToggle(): JSX.Element {
  const dispatch = useAppDispatch();

  const isCrossSectionEnabled = useAppSelector(
    selectCrossSectionEnabledForTomographicView,
  );

  const elevation = useAppSelector(selectSheetElevation);

  const { setSingleScreen } = useOverlayElements();
  const singleScreenRef = useOverlayRef(setSingleScreen);
  return (
    <ViewDiv
      eventDivRef={singleScreenRef}
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <CrossSectionToggleButton
        isEnabled={isCrossSectionEnabled}
        elevation={elevation}
        onToggleCrossSections={() => {
          dispatch(setCrossSectionEnabled(!isCrossSectionEnabled));
        }}
      />
    </ViewDiv>
  );
}
